import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import 'yet-another-react-lightbox/styles.css';

import HlsVideo from './HlsVideo';

import type { Memory } from '../../types/memory';

const MemoryAssets: React.FC<{ memory: Memory }> = ({ memory }) => {
  const [index, setIndex] = useState(-1);

  const files = memory.assets.map((asset) => {
    if (asset.media_type === 'video') {
      if (asset.path.includes('.m3u8')) {
        return {
          id: asset.id,
          type: 'hls-video' as const,
          poster: asset.thumbnail,
          thumbnail: asset.thumbnail,
          src: asset.path,
        };
      }
      return {
        id: asset.id,
        type: 'video' as const,
        thumbnail: asset.thumbnail,
        poster: asset.thumbnail,
        sources: [{
          src: asset.path,
          type: asset.type,
        }],
      };
    }
    return {
      id: asset.id,
      type: 'image' as const,
      thumbnail: asset.thumbnail,
      src: asset.path,
      alt: '',
    };
  });

  const handleVideoAutoplay = ({ index }: { index: number }) => {
    files.filter((slide) => ['hls-video', 'video'].includes(slide.type)).forEach((slide) => {
      if (slide.type === 'hls-video' || slide.type === 'video') {
        const videoElement = document.getElementById(`slider-video-${slide.id}`) as HTMLVideoElement | null;
        if (videoElement) {
          videoElement.pause();
        }
      }
    });

    const currentSlide = files[index];
    if (currentSlide.type === 'hls-video' || currentSlide.type === 'video') {
      const videoElement = document.getElementById(`slider-video-${currentSlide.id}`) as HTMLVideoElement | null;
      if (videoElement) {
        videoElement.play().catch(() => {});
      }
    }
  };

  return (
    <div className={`memory-assets memory-assets-${memory.variant}`}>
      <div className="wa-grid wa-gap-xs">
        <div className="memory-assets-left">
          <a href={`#${files[0]?.id}`} onClick={(e) => { e.preventDefault(); setIndex(0); }}>
            <img src={`${files[0]?.thumbnail}`} alt={files[0]?.alt} />
          </a>
        </div>
        {files.length > 1 && (
          <div className="wa-stack wa-gap-0 memory-assets-right">
            {files.slice(1, 3).map((file, i) => (
              <a key={file.id} href={`#${file.id}`} onClick={(e) => { e.preventDefault(); setIndex(i + 1); }}>
                {/* {file.type} */}
                <img src={`${file?.thumbnail}`} alt={file?.alt} />
              </a>
            ))}
            {files.length > 3 && (
              <a href={`#${files[3].id}`} onClick={(e) => { e.preventDefault(); setIndex(3); }} className="memory-assets-more">
                <div className="memory-assets-more-content">
                  +{files.length - 3}
                </div>
              </a>
            )}
          </div>
        )}
      </div>
      <Lightbox
        plugins={[Video]}
        render={{
          slide: ({ slide }) => {
            if (slide.type === 'hls-video') {
              return <HlsVideo slide={slide} />;
            }
            return undefined;
          }
        }}
        slides={files}
        open={index >= 0}
        index={index}
        on={{ view: ({ index }) => handleVideoAutoplay({ index }) }}
        close={() => setIndex(-1)}
      />
    </div>
  );
}

export default MemoryAssets
